export default () => ({
    // Nav is always visible on all screen sizes.
    // On desktop the top offset is managed by the alert-strip component
    // when the alert strip is visible (nav sits below the fixed alert strip).
    init() {
        // No scroll-based hide/show — nav stays sticky at all times
    }
})